import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuTrigger,
} from "@/components/ui/context-menu"
import permissions from "@/permissions";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from 'react-router-dom';
import { User } from "types";
import { UserPopover } from "../Popover/User";
import toast from "react-hot-toast";
export const ManageMember = ({ children, member }: { children: React.ReactNode, member: User }) => {
    const { teamId } = useParams();
    const kickUser = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/teams/${teamId}/members/${member.id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (data.message) return;
    };

    const queryClient = useQueryClient();
    const me = (queryClient.getQueryData(["team", teamId, "members", "@me"] as any) as any)?.member;
    const user = (queryClient.getQueryData(["user"] as any) as any);
    const roles = (queryClient.getQueryData(["team", teamId, "roles"]) as any)?.roles as any;
    const members = (queryClient.getQueryData(["team", teamId, "members"]) as any);
    const team = (queryClient.getQueryData(["team", teamId]) as any)?.team

    let userHighRole = roles?.reduce((acc: any) => {
        if (team.createdBy === member.id) return 999;
        let userM = members?.members?.find((member: any) => member.id === member.id);
        if (!userM.roles.includes(team.id)) userM?.roles.push(team.id);
        userM = userM?.roles.map((role: any) => roles.find((r: any) => r.id === role)?.priority);
        if (!userM) return acc;
        return Math.min(acc, Math.max(...userM));
    }, 0);

    let myHighRole = roles?.reduce((acc: any) => {
        if (team.createdBy === me.id) return 999;
        let userM = members?.members?.find((member: any) => member.id === me.id);
        if (!userM.roles.includes(team.id)) userM?.roles.push(team.id);
        userM = userM?.roles.map((role: any) => roles.find((r: any) => r.id === role)?.priority);
        if (!userM) return acc;
        return Math.min(acc, Math.max(...userM));
    }, 0);
    const blockOrUnblock = async () => {
        const isBlocked = user.blocked.find((block: any) => block.userId === member.id);
        await fetch(`__SITE_BASE__/api/me/users/${member.id}/block`, {
            method: user.blocked.find((block: any) => block.userId === member.id) ? "DELETE" : "POST",
            headers: { "Content-Type": "application/json" },
        });
        queryClient.setQueryData(["user"], (old: any) => {
            const updatedBlocked = isBlocked
                ? old.blocked.filter((block: any) => block.userId !== member.id)
                : [...old.blocked, { userId: member.id, blockedAt: new Date().toISOString() }];
            return { ...old, blocked: updatedBlocked };
        });

        toast.success(
            isBlocked
                ? `Unblocked ${member.username}`
                : `Blocked ${member.username}`
        );
    }

    return (
        <ContextMenu>
            <ContextMenuTrigger className="w-full">
                {children}
            </ContextMenuTrigger>
            <ContextMenuContent className="bg-brand-default gap-2 min-w-60 p-0 px-0 py-0 space-y-0 font-bold rounded-lg text-white border-0 shadow-xl shadow-brand">
                <UserPopover user={member}>
                    <ContextMenuItem className="hover:bg-brand-profile w-full text-white px-2 py-3 focus:text-white focus:bg-brand-profile" onSelect={(e) => {
                        e.preventDefault();
                    }}
                    
                    >
                        Profile
                    </ContextMenuItem>
                </UserPopover>
                {user?.user?.id !== member.id ? (
                    <ContextMenuItem className="hover:bg-brand-profile text-red-400 px-2 py-3 focus:text-red-400 focus:bg-brand-profile" onClick={blockOrUnblock}>
                        {user?.blocked?.find((block: any) => block.userId === member.id) ? "Unblock" : "Block"}
                    </ContextMenuItem>
                ) : null}

                {Boolean(BigInt(me?.permissions ?? '0') & permissions.get("MANAGE_TEAM" as string)!) && member.id != me.id && userHighRole <= myHighRole && team.createdBy !== member.id ? (

                    <div>
                        <hr className="border-gray-700 border-opacity-50 mb-2" />
                        <h1 className="text-gray-300 font-bold py-1 text-xs px-2">Manage Member</h1>
                        <ContextMenuItem className="hover:bg-brand-profile text-red-400 px-2 py-3 focus:text-red-400 focus:bg-brand-profile" onClick={kickUser}>
                            Kick {member.username}
                        </ContextMenuItem>
                    </div>
                ) : null}
            </ContextMenuContent>
        </ContextMenu>
    );

};